import {Stack, useMediaQuery, useTheme} from '@mui/material'
import logoImg from 'assets/images/cpslogo.png'
import {ENDPOINT} from 'config/path'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {type AppDispatch} from 'redux/store'
import {sessionRefreshListener} from 'services/login.service'
import HamMenu from './components/HamMenu'
import MenuCollection from './components/MenuCollection'
import ProfileCard from './components/ProfileCard'
import TopHeader from './components/TopHeader'
import {TopMenu} from './components/TopMenu'
import './index.scss'
import {getCarrierLogosAction} from 'features/Login/login.slice'
import _ from 'lodash'
import {
    getCarrierUserManagementPrivileges,
    getCarrierToolsPrivileges,
    getCarrierPrevilages,
    type ICarrierAdminAuthorizationConfig,
    type IServiceAdminUserAuthorizationConfig
} from 'shared/Header/components/data'
import AdminPrevilages, {type IBranchAdminAuthorizationConfig} from 'shared/Header/utils/AdminPrevilages'
import UserPrevilages from 'shared/Header/utils/UserPrevilages'
import {setUserAccessLevel, type IUserAccessLevels} from 'redux/common.slice'
import {
    BranchAdminUserManagementPrevilages,
    BranchUserUserManagementPrevilages,
    defaultBranchUserManagement
} from 'shared/Header/utils/BranchUserManagement'
import {BranchToolsPrevilages} from 'shared/Header/utils/BranchTools'
import ServiceAdminUserProfileConfig from 'shared/Header/utils/ServiceAdminUserProfileConfig'
import {
    ServiceAdminUserManagementPrevilages,
    defaultServiceAdminUserManagement
} from 'shared/Header/utils/ServiceAdminUserManagement'
import {ServiceAdminUserToolsPrevilages, defaultServiceAdminUserTools} from 'shared/Header/utils/ServiceAdminUserTools'
interface IUserDetail {
    userId: string
    firstName: string
    lastName: string
    carrierCode: string
    isBranchAdmin: boolean
    isBranchUser: boolean
    isMemberStatus: boolean
    isCoLoader: boolean
    isBookingEnabled: boolean
    isRatingEnabled: boolean
    isAllosEnabled: boolean
    isCarrierAdmin: boolean
    secondLevelCarrierAdmin: boolean
    isGSAEnabled: boolean
    isCarrierUser: boolean
    isAministratorStatus: boolean
    isServiceAdmin: boolean
    isServiceUser: boolean
    branchID: number
}

const Header = () => {
    const dispatch = useDispatch<AppDispatch>()
    const location = useLocation()
    const theme = useTheme()

    const belowMd = useMediaQuery(theme.breakpoints.down('md'))

    const [isSignedIn, setSignedIn] = useState<boolean>(false)
    const [isFaqPage, setFaqPage] = useState<boolean>(false)

    const isLoggedIn = useSelector((state: any) => state?.login?.isLoggedIn)
    const login = useSelector((state: any) => state?.login)
    const {isLoading: isPageLoading} = useSelector((state: any) => state?.login)

    const publicPathName = [ENDPOINT.homepage, ENDPOINT.faqpage, ENDPOINT.contactCPS]

    const carrierDetails = useSelector((state: any) => state?.ff_opsDashboard?.myCarriers?.response?.data || [])

    const userDetails: IUserDetail = useSelector(
        (state: any) =>
            state.login.loginDetails?.securityParams ||
            state.login.loginDetails || {
                firstName: '',
                lastName: '',
                branchStationCode: '',
                localStationCode: '',
                carrierCode: '',
                isBranchUser: false,
                isBranchAdmin: false,
                isCarrierUser: false,
                isCarrierAdmin: false,
                isMemberStatus: false,
                isBookingEnabled: false,
                isCoLoader: false,
                isRatingEnabled: false,
                isAllosEnabled: false,
                secondLevelCarrierAdmin: false,
                isGSAEnabled: false,
                isServiceAdmin: false,
                isServiceUser: false
            }
    )

    useEffect(() => {
        const isAuthenticated = async () => {
            const response = await sessionRefreshListener(false)
            if (
                localStorage.getItem('isLoggedIn')?.includes('true') &&
                isLoggedIn &&
                (response.status !== 202 || _.get(login, 'loginDetails.securityParams.isGuestUser', false))
            ) {
                setSignedIn(true)
            } else {
                setSignedIn(false)
            }
        }
        setFaqPage(location.pathname.toLowerCase().includes(ENDPOINT.faqpage))
        void isAuthenticated()
    }, [location.pathname, isLoggedIn])

    useEffect(() => {
        void dispatch(getCarrierLogosAction())
    }, [])

    const defaultAuthorization: IBranchAdminAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const defaultCarrierAuthorization: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const defaultServiceAuthorization: IServiceAdminUserAuthorizationConfig = {
        isBranchMemberStatus: false,
        isBranchAdministratorStatus: false,
        isCoLoaderStatus: false,
        isBookingAuthorization: false,
        isRateAuthorization: false,
        isAllocationAuthorization: false
    }

    const mapUserResponseAuthorizationConfig = {
        isBranchMemberStatus: 'isMemberStatus',
        isBranchAdministratorStatus: 'isBranchAdmin',
        isCoLoaderStatus: 'isCoLoader',
        isBookingAuthorization: 'isBookingEnabled',
        isRateAuthorization: 'isRatingEnabled',
        isAllocationAuthorization: 'isAllosEnabled'
    }

    const mapCarrierResponseAuthorizationConfig = {
        isAministratorStatus: 'isCarrierAdmin',
        isLevelofAdminRight: 'secondLevelCarrierAdmin',
        isGSAStatus: 'isGSAEnabled',
        isAllocation: 'isAllosEnabled',
        isRating: 'isRatingEnabled'
    }

    const mapServiceResponseAuthorizationConfig = {
        isBranchMemberStatus: 'isMemberStatus',
        isBranchAdministratorStatus: 'isBranchAdmin',
        isCoLoaderStatus: 'isCoLoader',
        isBookingAuthorization: 'isBookingEnabled',
        isRateAuthorization: 'isRatingEnabled',
        isAllocationAuthorization: 'isAllosEnabled'
    }

    Object.keys(mapUserResponseAuthorizationConfig).forEach((item) => {
        defaultAuthorization[item] = userDetails[mapUserResponseAuthorizationConfig[item]]
    })

    Object.keys(mapCarrierResponseAuthorizationConfig).forEach((item) => {
        defaultCarrierAuthorization[item] = userDetails[mapCarrierResponseAuthorizationConfig[item]]
    })

    Object.keys(mapServiceResponseAuthorizationConfig).forEach((item) => {
        defaultServiceAuthorization[item] = userDetails[mapServiceResponseAuthorizationConfig[item]]
    })

    useEffect(() => {
        if (userDetails.isBranchUser) {
            // Resetting the status to initial values
            const branchAdmin = userDetails.isBranchAdmin
            const userManagement = branchAdmin
                ? BranchAdminUserManagementPrevilages().get('BranchAdminUserManagement')
                : BranchUserUserManagementPrevilages().get('BranchUserUserManagement')
            const userTools = BranchToolsPrevilages().get('BranchToolsPrevilages')
            const userAccessConfig: IUserAccessLevels = {
                authorizationLevels: {},
                pageLevelAccess: {},
                userManagementAccess: userManagement ?? defaultBranchUserManagement,
                userToolsAccess: {
                    ...userTools,
                    isAAPayloadXMLSimulator: userDetails.branchID === 10010 || userDetails.branchID === 62431,
                    isXMLAuditor: userDetails.branchID === 10010
                },
                isMemberStatus: userDetails.isMemberStatus,
                isColoader: userDetails.isCoLoader
            }

            const previlageMapping = new Map([...AdminPrevilages(), ...UserPrevilages()])
            for (const previlage of previlageMapping.keys()) {
                if (_.isEqual(previlage, defaultAuthorization)) {
                    const branchAccessLevel = previlageMapping.get(previlage) ?? {}
                    userAccessConfig.authorizationLevels = {...defaultAuthorization}
                    userAccessConfig.pageLevelAccess = {...branchAccessLevel}
                }
            }
            dispatch(setUserAccessLevel(userAccessConfig))
        } else if (userDetails.isCarrierUser) {
            // Resetting the status to initial values
            const {carrierCode = '', isCarrierAdmin = false, secondLevelCarrierAdmin = false} = userDetails
            const userManagement = getCarrierUserManagementPrivileges(
                carrierCode,
                isCarrierAdmin,
                secondLevelCarrierAdmin
            )

            const userTools = getCarrierToolsPrivileges(carrierCode, isCarrierAdmin, secondLevelCarrierAdmin)
            const userAccessConfig: IUserAccessLevels = {
                authorizationLevels: {},
                pageLevelAccess: {},
                userManagementAccess: userManagement,
                userToolsAccess: userTools,
                isGSAStatus: userDetails.isGSAEnabled
            }

            const carrierPrevilageMapping = getCarrierPrevilages(userDetails.carrierCode)
            if (carrierPrevilageMapping !== null) {
                for (const carrierPrevilage of carrierPrevilageMapping.keys()) {
                    if (_.isEqual(carrierPrevilage, defaultCarrierAuthorization)) {
                        const carrierAccessLevel = carrierPrevilageMapping.get(carrierPrevilage) ?? {}
                        userAccessConfig.authorizationLevels = {...defaultCarrierAuthorization}
                        userAccessConfig.pageLevelAccess = {...carrierAccessLevel}
                    }
                }
            }
            dispatch(setUserAccessLevel(userAccessConfig))
        } else if (userDetails.isServiceUser || userDetails.isServiceAdmin) {
            // Resetting the status to initial values

            if (!defaultServiceAuthorization.isBranchAdministratorStatus) {
                defaultServiceAuthorization.isBranchAdministratorStatus = true
            }

            const userManagement = ServiceAdminUserManagementPrevilages().get('ServiceAdminUserManagement')
            const userTools = ServiceAdminUserToolsPrevilages().get('ServiceAdminTools')
            const userAccessConfig: IUserAccessLevels = {
                authorizationLevels: {},
                pageLevelAccess: {},
                userManagementAccess: userManagement ?? defaultServiceAdminUserManagement,
                userToolsAccess: userTools ?? defaultServiceAdminUserTools
            }

            const servicePrevilageMapping = new Map([...ServiceAdminUserProfileConfig()])
            for (const servicePrevilage of servicePrevilageMapping.keys()) {
                if (_.isEqual(servicePrevilage, defaultServiceAuthorization)) {
                    const serviceAccessLevel = servicePrevilageMapping.get(servicePrevilage) ?? {}
                    userAccessConfig.authorizationLevels = {...defaultServiceAuthorization}
                    userAccessConfig.pageLevelAccess = {...serviceAccessLevel}
                }
            }

            dispatch(setUserAccessLevel(userAccessConfig))
        }
    }, [userDetails])

    useEffect(() => {
        if (userDetails.isBranchUser && carrierDetails?.length > 0) {
            const approvedCarriers = carrierDetails
                ?.filter((item: Record<string, any>) => item.status === 'Approved')
                .map((item: Record<string, any>) => item?.carrier)

            const eClaimsAllowedCarriers = ['AC', 'AI', 'MH', 'SK']
            const isCarrierApproved = approvedCarriers.filter((carrier: string) =>
                eClaimsAllowedCarriers.includes(carrier)
            )

            const updatedBranchAccessLevel = {
                ViewACClaimStatus: isCarrierApproved.includes('AC') ? 'Y' : 'N',
                ViewAIClaimStatus: isCarrierApproved.includes('AI') ? 'Y' : 'N',
                ViewMHClaimStatus: isCarrierApproved.includes('MH') ? 'Y' : 'N',
                ViewSKClaimStatus: isCarrierApproved.includes('SK') ? 'Y' : 'N'
            }
            dispatch(setUserAccessLevel({pageLevelAccess: updatedBranchAccessLevel}))
        }
    }, [carrierDetails])

    const RenderLogo = () => (
        <a tabIndex={-1} href={`${process.env.PUBLIC_URL}${ENDPOINT.homepage}`}>
            <img tabIndex={0} src={logoImg} alt='CPS Logo' className='appLogo headerImg' />
        </a>
    )
    return (
        <>
            {isSignedIn && !isPageLoading && !belowMd && <TopHeader />}
            <header
                className={
                    !isSignedIn &&
                    publicPathName.some((item) => location.pathname.toLowerCase().includes(item.toLowerCase()))
                        ? 'fixed-header'
                        : ''
                }
                id='headerContainer'
            >
                <Stack direction='row' className='headerGrid'>
                    <Stack direction='row' className={`leftStack ${!isSignedIn && isFaqPage ? 'justifyContent' : ''}`}>
                        <RenderLogo />
                        {!isSignedIn &&
                            publicPathName.some((item) =>
                                location.pathname.toLowerCase().includes(item.toLowerCase())
                            ) && <MenuCollection publicPathName={publicPathName} />}
                        {isSignedIn && !isPageLoading && (
                            <Stack direction='row' className='menuItems'>
                                {!belowMd && <TopMenu />}
                            </Stack>
                        )}
                    </Stack>
                    {isSignedIn && !isPageLoading && (
                        <Stack direction='row'>
                            {!belowMd && <ProfileCard />}
                            {belowMd && <HamMenu />}
                        </Stack>
                    )}
                </Stack>
            </header>
        </>
    )
}

export default Header
